import React from "react";

class LeavesHerbs extends React.Component{
    render(){
        return(<div></div>)
    }
}

export default LeavesHerbs;